import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CSlider from '@/components/shared/CSlider.vue';
import ElementLibrarySelector from '@/components/DesignStudio/ElementLibrarySelector.vue';
import { LibraryTypeEnum } from '@/utils/enums/libraryType.enum';
import { ShadowTypeEnum } from '@/utils/enums/shadowType.enum';
import type { ShadowSettingsApi } from '@/composables/shadowSettings';

type ShadowVariant = 'text' | 'image';

// The thumbnails preview the shadow on the element it belongs to, so each variant gets its own art

export default /*#__PURE__*/_defineComponent({
  __name: 'ShadowSettings',
  props: {
    shadow: null,
    cmykMode: { type: Boolean },
    isPreview: { type: Boolean, default: false },
    variant: { default: 'text' }
  },
  setup(__props: any) {

const props = __props as { shadow: ShadowSettingsApi, cmykMode?: boolean, isPreview: boolean, variant: ShadowVariant };

/**
 * The shadow panel every element shares: the type thumbnails, the offset/angle/blur sliders and the
 *  color options, wired to the shadow API of whatever element the parent points at.
 *
 * Giving a shadow to a new element is a fabric class implementing ShadowElement plus a thin wrapper
 *  that renders this component, not another copy of the panel.
 */
const COLOR_TYPE = LibraryTypeEnum.Color;
const BLURRED_SHADOW = ShadowTypeEnum.Blurred;

const shadowThumbnails: Record<ShadowVariant, Record<ShadowTypeEnum, string>> = {
    text: {
        [ShadowTypeEnum.Drop]: require('@/assets/images/drop-shadow.svg'),
        [ShadowTypeEnum.Blurred]: require('@/assets/images/blurred-drop-shadow.svg')
    },
    image: {
        [ShadowTypeEnum.Drop]: require('@/assets/images/drop-shadow-image.svg'),
        [ShadowTypeEnum.Blurred]: require('@/assets/images/blur-shadow-image.svg')
    }
};

const shadowTypes = [
    { type: ShadowTypeEnum.Drop, label: 'Drop shadow' },
    { type: ShadowTypeEnum.Blurred, label: 'Blurred drop shadow' }
];



const shadowOptions = computed(() =>
    shadowTypes.map((option) => ({ ...option, img: shadowThumbnails[props.variant][option.type] }))
);

const model = computed(() => props.shadow.model);
const colors = computed(() => props.shadow.colors);
const disabled = computed(() => props.shadow.disabled.value);

const selectType = (type: ShadowTypeEnum) => {
    if (disabled.value) return;
    props.shadow.changeShadowType(type);
};

return { __sfc: true,COLOR_TYPE, BLURRED_SHADOW, shadowThumbnails, shadowTypes, props, shadowOptions, model, colors, disabled, selectType, CSlider, ElementLibrarySelector }
}

})